import { render, staticRenderFns } from "./FactoryList.vue?vue&type=template&id=be90079a&scoped=true&"
import script from "./FactoryList.vue?vue&type=script&lang=js&"
export * from "./FactoryList.vue?vue&type=script&lang=js&"
import style0 from "./FactoryList.vue?vue&type=style&index=0&id=be90079a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be90079a",
  null
  
)

component.options.__file = "FactoryList.vue"
export default component.exports